<template>
  <v-menu
    v-model="menu"
    :close-on-content-click="false"
    :nudge-width="240"
    :nudge-left="240"
    offset-y
  >
    <template v-slot:activator="{ on }">
      <v-btn
        block
        v-on="on"
      >
        {{ text }}
      </v-btn>
    </template>

    <v-card>
      <v-container fluid>
        <v-row>
          <v-col cols="12" class="text-center display-1">
            {{ text }}
          </v-col>
        </v-row>
      </v-container>

      <v-card-actions>
        <v-spacer></v-spacer>

        <v-container fluid>
          <v-row>
            <v-col cols="2" v-if="hasInfValues">
              <v-btn block x-small :color="isPlusInf ? 'primary' : null" @click="toggleInfValue(conversionInfo.plusInfValue)">+INF</v-btn>
            </v-col>
            <v-col cols="2" v-for="(step, index) in conversionInfo.steps" :key="index">
              <v-btn block x-small :disabled="isAnyInf" @click="changeValue(step.value)">+{{ step.text }}</v-btn>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="2" v-if="hasInfValues">
              <v-btn block x-small :color="isMinusInf ? 'primary' : null" @click="toggleInfValue(conversionInfo.minusInfValue)">-INF</v-btn>
            </v-col>
            <v-col cols="2" v-for="(step, index) in conversionInfo.steps" :key="index">
              <v-btn block x-small :disabled="isAnyInf" @click="changeValue(-step.value)">-{{ step.text }}</v-btn>
            </v-col>
          </v-row>
          <v-row v-if="conversions">
            <v-col cols="12">
              <v-select :items="conversions" v-model="selected_conversion" @change="conversion_changed">
              </v-select>
            </v-col>
          </v-row>
        </v-container>
      </v-card-actions>
    </v-card>
  </v-menu>
</template>

<script>
// FIXME bzgl Namenskonvention überarbeiten
const rawTemperature = {
  steps: [{
    text: '100',
    value: 100,
  }, {
    text: '10',
    value: 10,
  }, {
    text: '1',
    value: 1,
  }, {
    text: '0.1',
    value: 0.1,
  }],
  minimumValue: -140,
  maximumValue: 260,
  plusInfValue: 888.8,
  minusInfValue: -888.8,
  toRawValue(value) {
    return {
      value,
      type: 0, // FIXME sollte 1 (=raw) zurück geben; alle Vorkommen ersetzen
    };
  },
  toStringValue(value) {
    return `${value.toFixed(1)} °C`;
  },
};

// FIXME bzgl Namenskonvention überarbeiten
const ntcTemperature = {
  steps: [{
    text: '10',
    value: 10,
  }, {
    text: '1',
    value: 1,
  }],
  minimumValue: -10,
  maximumValue: 120,
  plusInfValue: 888.8,
  minusInfValue: -888.8,
  toRawValue(value) {
    return {
      value,
      type: 0,
    };
  },
  toStringValue(value) {
    return `${value.toFixed(1)} °C`;
  },
};

// FIXME bzgl Namenskonvention überarbeiten
const rawFlow = {
  steps: [{
    text: '100',
    value: 100,
  }, {
    text: '10',
    value: 10,
  }, {
    text: '1',
    value: 1,
  }, {
    text: '0.1',
    value: 0.1,
  }],
  minimumValue: 0,
  maximumValue: 1000,
  plusInfValue: 888.8,
  minusInfValue: -888.8,
  toRawValue(value) {
    return {
      value,
      type: 0, // FIXME sollte 1 (=raw) zurück geben; alle Vorkommen ersetzen
    };
  },
  toStringValue(value) {
    return `${value.toFixed(1)} l/min`;
  },
};

// FIXME bzgl Namenskonvention überarbeiten
const rawPressure = {
  steps: [{
    text: '1',
    value: 1,
  }, {
    text: '0.1',
    value: 0.1,
  }, {
    text: '0.01',
    value: 0.01,
  }],
  minimumValue: 0,
  maximumValue: 10,
  plusInfValue: 888.8,
  minusInfValue: -888.8,
  toRawValue(value) {
    return {
      value,
      type: 0, // FIXME sollte 1 (=raw) zurück geben; alle Vorkommen ersetzen
    };
  },
  toStringValue(value) {
    return `${value.toFixed(2)} bar`;
  },
};

// FIXME bzgl Namenskonvention überarbeiten
const rawHumidity = {
  steps: [{
    text: '10',
    value: 10,
  }, {
    text: '1',
    value: 1,
  }],
  minimumValue: 0,
  maximumValue: 100,
  plusInfValue: 888.8,
  minusInfValue: -888.8,
  toRawValue(value) {
    return {
      value,
      type: 0, // FIXME sollte 1 (=raw) zurück geben; alle Vorkommen ersetzen
    };
  },
  toStringValue(value) {
    return `${value.toFixed(0)} %`;
  },
};

// FIXME bzgl Namenskonvention überarbeiten
const rawPercent = {
  steps: [{
    text: '100',
    value: 100,
  }, {
    text: '10',
    value: 10,
  }, {
    text: '1',
    value: 1,
  }, {
    text: '0.1',
    value: 0.1,
  }],
  minimumValue: 0,
  maximumValue: 100,
  plusInfValue: 888.8,
  minusInfValue: -888.8,
  toRawValue(value) {
    return {
      value,
      type: 0, // FIXME sollte 1 (=raw) zurück geben; alle Vorkommen ersetzen
    };
  },
  toStringValue(value) {
    return `${value.toFixed(1)} %`;
  },
};

// FIXME bzgl Namenskonvention überarbeiten
const rawFrequency = {
  steps: [{
    text: '100',
    value: 100,
  }, {
    text: '10',
    value: 10,
  }, {
    text: '1',
    value: 1,
  }, {
    text: '0.1',
    value: 0.1,
  }],
  minimumValue: 0,
  maximumValue: 10000,
  plusInfValue: 0,
  minusInfValue: 0,
  toRawValue(value) {
    return {
      value: value * 1000,
      type: 128, // FIXME sollte 1 (=raw) zurück geben; alle Vorkommen ersetzen
    };
  },
  toStringValue(value) {
    return `${value.toFixed(1)} Hz`;
  },
};

// FIXME bzgl Namenskonvention überarbeiten
const rawPower = {
  steps: [{
    text: '1000',
    value: 1000,
  }, {
    text: '100',
    value: 100,
  }, {
    text: '10',
    value: 10,
  }, {
    text: '1',
    value: 1,
  }],
  minimumValue: -5000,
  maximumValue: 5000,
  toRawValue(value) {
    return {
      value,
      type: 0, // FIXME sollte 1 (=raw) zurück geben; alle Vorkommen ersetzen
    };
  },
  toStringValue(value) {
    return `${value.toFixed(0)} W`;
  },
};

// FIXME bzgl Namenskonvention überarbeiten
const rawRadonConcentration = { // FIXME(robin) Wertebereich definieren
  steps: [{
    text: '100',
    value: 100,
  }, {
    text: '10',
    value: 10,
  }, {
    text: '1',
    value: 1,
  }, {
    text: '0.1',
    value: 0.1,
  }],
  minimumValue: -40,
  maximumValue: 260,
  plusInfValue: 888.8,
  minusInfValue: -888.8,
  toRawValue(value) {
    return {
      value,
      type: 32768, // FIXME sollte 1 (=raw) zurück geben; alle Vorkommen ersetzen
    };
  },
  toStringValue(value) {
    return `${value.toFixed(1)} Bq/m^3`;
  },
};

// FIXME bzgl Namenskonvention überarbeiten
const rawUpm = {
  steps: [{
    text: '1000',
    value: 1000,
  }, {
    text: '100',
    value: 100,
  }],
  minimumValue: 0,
  maximumValue: 6000,
  plusInfValue: 8888.8,
  minusInfValue: -8888.8,
  toRawValue(value) {
    return {
      value,
      type: 0, // FIXME sollte 1 (=raw) zurück geben; alle Vorkommen ersetzen
    };
  },
  toStringValue(value) {
    return `${value.toFixed(0)} rpm`;
  },
};

// FIXME bzgl Namenskonvention überarbeiten
const rawDigital = {
  steps: [{
    text: '1',
    value: 1,
  }],
  minimumValue: 0,
  maximumValue: 1,
  toRawValue(value) {
    return {
      value,
      type: 2, // FIXME sollte 1 (=raw) zurück geben; alle Vorkommen ersetzen
    };
  },
  toStringValue(value) {
    return `${value.toFixed(1)}`;
  },
};

// FIXME bzgl Namenskonvention überarbeiten
const rawIaq = { // FIXME(robin) Wertebereich definieren
  steps: [{
    text: '100',
    value: 100,
  }, {
    text: '10',
    value: 10,
  }, {
    text: '1',
    value: 1,
  }, {
    text: '0.1',
    value: 0.1,
  }],
  minimumValue: 0,
  maximumValue: 100,
  plusInfValue: 888.8,
  minusInfValue: -888.8,
  toRawValue(value) {
    return {
      value,
      type: 0, // FIXME sollte 1 (=raw) zurück geben; alle Vorkommen ersetzen
    };
  },
  toStringValue(value) {
    return `${value.toFixed(1)}`;
  },
};

// FIXME bzgl Namenskonvention überarbeiten (NK)
const raw = { // FIXME(robin) Wertebereich definieren
  steps: [{
    text: '100',
    value: 100,
  }, {
    text: '10',
    value: 10,
  }, {
    text: '1',
    value: 1,
  }, {
    text: '0.1',
    value: 0.1,
  }],
  minimumValue: -16383,
  maximumValue: 16383,
  plusInfValue: 888.8,
  minusInfValue: -888.8,
  toRawValue(value) {
    return {
      value,
      type: 1,
    };
  },
  toStringValue(value) {
    return `${value.toFixed(1)}`;
  },
};

const resistorPt1000Temperature = Object.assign({}, rawTemperature, {
  toRawValue(value) {
    return {
      value: (7.61247 - Math.pow((value - 3383.81) / -1315.9, 2)) * 1000000,
      type: 32,
    };
  },
});


// const double _KOEFF_NTC_MF58_5K_B35[] = {KOEFFIZIENT_A_5K_MINUS30_PLUS30_PLUS120, KOEFFIZIENT_B_5K_MINUS30_PLUS30_PLUS120, KOEFFIZIENT_C_5K_MINUS30_PLUS30_PLUS120};
// Typ muss double sein!!


//NTC MF58502-35:
const ntcResistorToTemperatureCelsius = (Resistor) => {
	const a = 0.0010657;
  const b = 0.000258695;
  const c = 0.000000136806;

	return ( 1.0 / (a + b * Math.log(Resistor) + c * Math.pow(Math.log(Resistor), 3.0) )) - 273.15;
};

// 14000 Ohm = 0.4 °C
// 9200 Ohm = 10.0 °C
// 6100 Ohm = 20.0 °C
// 4100 Ohm = 30.2 °C
// 2800 Ohm = 40.5 °C
// 2000 Ohm = 50.2 °C
// 1450 Ohm = 60.0 °C
// 1060 Ohm = 70.0 °C
// 780 Ohm = 80.3 °C
// 590 Ohm = 90.2 °C
// 450 Ohm = 100.3 °C
// 350 Ohm = 110.1° C
// 275 Ohm = 120.0 °C => Resistorwert wird vom Regler schon als Fehler gewertet
const ntcValueCount = 13;
const ntcStartValues = [14000, 9200, 6100, 4100, 2800, 2000, 1450, 1060, 780, 590, 450, 350, 275]; // Resistor
const ntcStartTemps = [0.4, 10.0, 20.0, 30.2, 40.5, 50.2, 60.0, 70.0, 80.3, 90.2, 100.3, 110.1, 120.0]; //°C
const ntcStepLength = [300, 200, 150, 100, 60, 50, 20, 20, 10, 10, 5, 5, 5];

const resistorNTC_MF58_5K_B35Temperature = Object.assign({}, ntcTemperature, {
  toRawValue(value) {
    let Result, Resistor, Step;
    const Index = ((value - 5) / 10).toFixed(0);
    // console.log('soll ', value)
    if (Index < 0) {
      Resistor = ntcStartValues [0];
      Result = ntcStartTemps [0];
      Step = ntcStepLength [0];
    } else if (Index > ntcValueCount) {
      Resistor = ntcStartValues [ntcValueCount - 1];
      Result = ntcStartTemps [ntcValueCount - 1];
      Step = ntcStepLength [ntcValueCount - 1];
    } else {
      Resistor = ntcStartValues [Index];
      Result = ntcStartTemps [Index];
      Step = ntcStepLength [Index];
    }
    // console.log('start with ', Resistor, 'Ohm', Result, 'C  step ', Step);

    // let count = 0;
    while ((Result < value) && (Resistor > Step)) {
      Resistor -= Step;
      Result = ntcResistorToTemperatureCelsius(Resistor);
      // count++;
    }
    // console.log('  ==> ', Resistor, 'Ohm', Result, 'C   ', count, ' Steps');

    // let Value = 300;
    // for (let i = 0; i < 20; i++) {
    //   Value -= 5;
    //   let Temp = ntcResistorToTemperatureCelsius(Value);
    //   console.log(Value, ' Ohm = ', Temp, ' C');
    // }

    return {
      value: Resistor * 1000.0,
      type: 32,
    };
  },
});


const frequencyGrundfos_UPM4_Profile17 = Object.assign({}, rawFrequency, {
  toRawValue(value) {
    return {
      value,
      type: 128,
    };
  },
});


const frequencyFAN = Object.assign({}, rawUpm, {
  toRawValue(value) {
    return {
      value: value * 2000 / 60,
      type: 128,
    };
  },
});


const frequencyHuba_200_9110xxNFlow = Object.assign({}, rawFlow, {
  toRawValue(value) {
    return {
    //   value: value,
      value: ((value + 0.2) / 0.0000841),
      type: 128,
    };
  },
});


const frequencyHUBA_201_99003Flow = Object.assign({}, rawFlow, {
  toRawValue(value) {
    return {
    //   value: value,
      value: ((value + 0.2) / 0.0000837),
      type: 128,
    };
  },
});

const frequencyHUBA_201_825151Flow = Object.assign({}, rawFlow, {
  toRawValue(value) {
    return {
      value: ((value + 0.5) / 0.0007306),
      type: 128,
    };
  },
});

const frequencySIKA_VY2060MAHN = Object.assign({}, rawFlow, {
  toRawValue(value) {
    value = 60 * value;
    return {
      //value: value <= 40 ? 0 : ((value - 40) / 45) * 1000,
      value: value * 100.0 / 6.0 / 0.5042,
      type: 128,
    };
  },
});
const frequencySIKA_VY2060VAHN = Object.assign({}, rawFlow, {
  toRawValue(value) {
    value = 60 * value;
    return {
      //value: value <= 40 ? 0 : ((value - 40) / 45) * 1000,
      value: value * 100.0 / 6.0 / 0.4918,
      type: 128,
    };
  },
});
const frequencySIKA_VY1030K5HN = Object.assign({}, rawFlow, {
  toRawValue(value) {
    value = 60 * value;
    return {
      //value: value <= 40 ? 0 : ((value - 40) / 45) * 1000,
      value: value * 100.0 / 6.0 / 0.1132,
      type: 128,
    };
  },
});
const frequencySIKA_VY1545MAHN = Object.assign({}, rawFlow, {
  toRawValue(value) {
    value = 60 * value;
    return {
      //value: value <= 40 ? 0 : ((value - 40) / 45) * 1000,
      value: value * 100.0 / 6.0 / 0.2564,
      type: 128,
    };
  },
});
const frequencySIKA_VY1030MAHN = Object.assign({}, rawFlow, {
  toRawValue(value) {
    value = 60 * value;
    return {
      //value: value <= 40 ? 0 : ((value - 40) / 45) * 1000,
      value: value * 100.0 / 6.0 / 0.1212,
      type: 128,
    };
  },
});

const frequencyPAW_FlowRotor_DN20 = Object.assign({}, rawFlow, {
  toRawValue(value) {
    value = 60 * value;
    return {
      value: value <= 17.6 ? 0 : ((value - 17.6) / 19.386) * 1000,
      type: 128,
    };
  },
});


const frequencyPAW_FlowRotor_DN25 = Object.assign({}, rawFlow, {
  toRawValue(value) {
    value = 60 * value;
    return {
      value: value <= 40 ? 0 : ((value - 40) / 45) * 1000,
      type: 128,
    };
  },
});

// const frequencyPAW_FlowRotor_DN32 = Object.assign({}, rawFlow, {
//   toRawValue(value) {
//     value = 60 * value;
//     return {
//       value: value <= 40 ? 0 : ((value - 40) / 45) * 1000, // fix values
//       type: 128,
//     };
//   },
// });
//
const voltageGaTemperature = Object.assign({}, rawTemperature, {
  toRawValue(value) {
    const rawValue = (0.5 + value / 100 * 3) * 1000000;

    return {
      value: rawValue,
      type: 4,
    };
  },
});

const voltageVfsFlow = Object.assign({}, rawFlow, {
  toRawValue(value) {
    const rawValue = (value < 0.05) ? 300000 : ((0.5 + (value - 2) / (40 - 2) * 3) * 1000000);

    return {
      value: rawValue,
      type: 4,
    };
  },
});

const voltageRpsPressure = Object.assign({}, rawPressure, {
  toRawValue(value) {
    const rawValue = (0.5 + value / 6 * 3) * 1000000;

    return {
      value: rawValue,
      type: 4,
    };
  },
});

const voltageRpsPressure0to10 = Object.assign({}, rawPressure, {
  toRawValue(value) {
    const rawValue = (0.5 + value / 10 * 3) * 1000000;

    return {
      value: rawValue,
      type: 4,
    };
  },
});

const voltageRhTemperature = Object.assign({}, rawTemperature, {
  toRawValue(value) {
    const rawValue = (value + 66.875) / 218.75 * 3300000;

    return {
      value: rawValue,
      type: 4,
    };
  },
});

const voltageRhHumidity = Object.assign({}, rawHumidity, {
  toRawValue(value) {
    const rawValue = (0.5 + value / 100 * 3) * 1000000;

    return {
      value: rawValue,
      type: 4,
    };
  },
});

const voltage = Object.assign({}, raw, {
  toRawValue(value) {
    const rawValue = value;

    return {
      value: rawValue,
      type: 4,
    };
  },
});

const v10Vin = {
  steps: [{
    text: '1.0',
    value: 1.0,
  }, {
    text: '0.1',
    value: 0.1,
  // }, {
  //   text: '0.01',
  //   value: 0.01,
  }],
  minimumValue: -1,
  maximumValue: 20,
  toRawValue(value) {
    const rawValue = value * 1000000;

    return {
      value: rawValue,
      type: 4,
    };
  },
  toStringValue(value) {
    return `${value.toFixed(1)} V`;
  },
};

const linVlcpTemperature = Object.assign({}, rawTemperature, {
  toRawValue(value) {
    const rawValue = (value + 20) * 10;

    return {
      value: rawValue,
      type: 0,
    };
  }
});

const linVlcpFlow = Object.assign({}, rawFlow, {
  toRawValue(value) {
    const rawValue = value * 60 / 10;

    return {
      value: rawValue,
      type: 0,
    };
  },
});

const temperature = Object.assign({}, rawTemperature, {
  toRawValue(value) {
    return {
      value: value * 1000,
      type: 512,
    };
  },
});


const digitalState = {
  steps: [{
    text: '1',
    value: 1,
  }],
  minimumValue: 0,
  maximumValue: 1,
  plusInfValue: null,
  minusInfValue: null,
  toStringValue(value) {
    return `${value}`;
  },

  toRawValue(rawValue) {
    return {
      value: rawValue,
      type: 2,
    };
  },
};

const conversionById = {
  rawTemperature,
  rawFlow,
  rawPressure,
  rawHumidity,
  rawPercent,
  rawFrequency,
  rawPower,
  rawRadonConcentration,
  rawDigital,
  rawIaq,
  rawUpm,
  raw,
  ntcTemperature,

  resistorPt1000Temperature,
  resistorNTC_MF58_5K_B35Temperature,
  voltageGaTemperature,
  voltageVfsFlow,
  voltageRpsPressure,
  voltageRpsPressure0to10,
  voltageRhTemperature,
  voltageRhHumidity,
  voltage,
  v10Vin,
  linVlcpTemperature,
  linVlcpFlow,
  frequencyHuba_200_9110xxNFlow,
  frequencyHUBA_201_99003Flow,
  frequencyHUBA_201_825151Flow,
  frequencyPAW_FlowRotor_DN20,
  frequencyPAW_FlowRotor_DN25,
  frequencySIKA_VY2060MAHN,
  frequencySIKA_VY2060VAHN,
  frequencySIKA_VY1030K5HN,
  frequencySIKA_VY1030MAHN,
  frequencySIKA_VY1545MAHN,
  // frequencyPAW_FlowRotor_DN32,
  frequencyGrundfos_UPM4_Profile17,
  frequencyFAN,
  digitalState,
  temperature,
};

export default {
  props: [
    'name',
    'conversion',
    'conversions',
    'initialValue',
    'value',
  ],

  data: () => ({
    userFriendlyValue: 0,
    hasInfValues: false,
    isPlusInf: false,
    isMinusInf: false,
    isAnyInf: false,
    selected_conversion: null,
    menu: false,
    isInfUserFriendlyValue: false,
    preInfUserFriendlyValue: null,
    text: '',
  }),

  computed: {
    conversionInfo() {
      return conversionById [this.selected_conversion] || {};
    },
  },

  mounted() {
    this.selected_conversion = this.conversion;
    this.setValue(this.initialValue || 0);
  },

  methods: {
    conversion_changed () {
      // this.selected_conversion;
      this.setValue(this.userFriendlyValue);
    },
    setValue(value) {
      const conv = this.conversionInfo;
      this.hasInfValues = (conv.plusInfValue !== conv.minusInfValue);
      this.isPlusInf = this.hasInfValues && (value === conv.plusInfValue);
      this.isMinusInf = this.hasInfValues && (value === conv.minusInfValue);
      this.isAnyInf = (this.isPlusInf || this.isMinusInf);

      if (!this.isAnyInf) {
        this.preInfUserFriendlyValue = value;
      }

      this.userFriendlyValue = value;

      const rawValue = conv.toRawValue(value);
      this.$emit('input', rawValue);

      this.updateText();
    },

    customizeConversion(id, custom) {
      let conversion = conversionById [id];
      if (conversion) {
        conversion.maximumValue = custom.maximumValue || conversion.maximumValue;
        conversion.minimumValue = custom.minimumValue || conversion.minimumValue;
      } else {
        throw new Error(`Could not find conversion ${id}`);
      }
    },

    changeValue(delta) {
      const conv = this.conversionInfo;

      let oldValue = this.preInfUserFriendlyValue;

      let newValue = oldValue + delta;
      if (newValue < conv.minimumValue) {
        newValue = conv.minimumValue;
      } else if (newValue > conv.maximumValue) {
        newValue = conv.maximumValue;
      }

      this.setValue(newValue);
    },

    toggleInfValue(infValue) {
      if (this.userFriendlyValue === infValue) {
        this.setValue(this.preInfUserFriendlyValue);
      } else {
        this.setValue(infValue);
      }
    },

    updateText() {
      const conv = this.conversionInfo;
      const stringValue = conv.toStringValue(this.userFriendlyValue);
      this.text = `${this.name}: ${stringValue}`;
    }
  }
};
</script>

<style scoped>

</style>
